import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import userauth from './components/userauth.vue'
import ads from './components/ads.vue'

// firebase
import firebase from 'firebase/app'
import 'firebase/firestore'
firebase.initializeApp({
  apiKey: "AIzaSyBfe33Ej0Zc-aV0PQTZdscFIvuxJVxybwA",
  authDomain: "daytona-local.firebaseapp.com",
  databaseURL: "https://daytona-local.firebaseio.com",
  projectId: "daytona-local",
  storageBucket: "daytona-local.appspot.com",
  messagingSenderId: "83626678742"
});
export const fsd = firebase.firestore()

import 'firebase/auth'
export const auth = firebase.auth()

import 'firebase/storage'
export const storage = firebase.storage()

// Fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome, faCalendar, faMap, faUtensils, faBriefcase, faChartLine, faInfoCircle, faPencilAlt, faTrash, faCopy, faCreditCard, faArrowLeft, faArrowRight, faBars, faList, faCheckCircle, faTimes, faChartBar, faGlobe, faPhone, faClock, faNewspaper, faCalendarPlus, faUser, faUserShield, faTree } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF, faTwitter, faGooglePlus } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { dom } from '@fortawesome/fontawesome-svg-core'
library.add(faHome, faCalendar, faMap, faUtensils, faBriefcase, faChartLine, faInfoCircle, faFacebookF, faTwitter, faGooglePlus, faPencilAlt, faTrash, faCopy, faCreditCard, faArrowLeft, faArrowRight, faBars, faList, faCheckCircle, faTimes, faChartBar, faGlobe, faPhone, faClock, faNewspaper, faCalendarPlus, faUser, faUserShield, faTree)
dom.watch()


// Subscribe to store updates
store.subscribe((mutation, state) => {
	// Store the state object as a JSON string
	localStorage.setItem('store', JSON.stringify(state));
});

// currency filter
Vue.filter('currency', (value) => {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
  });
  return formatter.format(value);
})
// titlecase filter
Vue.filter('titlecase', (string) => {
  return string.replace(/([^\W_]+[^\s-]*) */g, function(s) {
    return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase();
  });
})
// capitalize filter
Vue.filter('capitalize', (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
})
// sort filter
Vue.filter('sort', (array, sortBy, direction) => {
  if (direction === 'asc') {
    array.sort((a, b) => a[sortBy] - b[sortBy]);
  } else {
    array.sort((a, b) => b[sortBy] - a[sortBy]);
  }
  return array
})
// shuffle filter
Vue.filter('shuffle', (array, limit) => {
  for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
  }
  if (array.length > limit) {
    array = array.slice(0, limit)
  }
  return array
})
// truncate filter
Vue.filter('truncate', (value, limit) => {
  if (value.length > limit) {
    value = value.substring(0, (limit - 3)) + '...'
  }
  return value
})
// limit filter
Vue.filter('limit', (array, limit) => {
  if (array.length > limit) {
    array = array.slice(0, limit)
  }
  return array
})
// slice filter
Vue.filter('slice', (string, limit) => {
  if (string.length > limit) {
    string = string.slice(0, limit)
  }
  return string
})
// date filter
import moment from 'moment'
Vue.filter('date', (value, format) => {
  if (value) {
           if (format === 'day') {
      return moment(value).format('MMM DD')
    } else if (format === 'full') {
      return moment(value).format('MM/DD/YYYY hh:mma')
    } else if (format === 'longDate') {
      return moment(value).format('dddd, MMMM Do, YYYY')
    } else if (format === 'mediumDate') {
      return moment(value).format('MMM DD, YYYY')
    } else if (format === 'shortDate') {
      return moment(value).format('MM/DD/YYYY')
    } else if (format === 'dayTime') {
      return moment(value).format('MMM DD hh:mma')
    } else if (format === 'dayNumber') {
      return moment(value).format('DD')
    } else if (format === 'monthString') {
      return moment(value).format('MMMM')
    } else if (format === 'year') {
      return moment(value).format('YYYY')
    } else if (format === 'monthStringShort') {
      return moment(value).format('MMM')
    } else if (format === 'year') {
      return moment(value).format('YYYY')
    } else if (format === 'time') {
      return moment(value).format('hh:mma')
    }
  }
})
// slug filter
Vue.filter('slug', (string) => {
  if (string) {
    const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœøṕŕßśșțùúüûǘẃẍÿź·/_,:;'
    const b = 'aaaaaaaaceeeeghiiiimnnnooooooprssstuuuuuwxyz------'
    const p = new RegExp(a.split('').join('|'), 'g')
    return string.toString().toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, '-and-') // Replace & with ‘and’
      .replace(/\-([0-9])/g, '') // Replace -[0-9]
      .replace(/[^\w\-]+/g, '') // Remove all non-word characters
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, '') // Trim - from end of text
  }
})

// Vue Meta
import VueMeta from 'vue-meta'
Vue.use(VueMeta)

// Initiate Components
Vue.component('userauth', require('@/components/userauth.vue').default)
Vue.component('ads', require('@/components/ads.vue').default)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;

// init app
new Vue({
  router,
  store,
  components: {
    userauth,
    ads
  },
  render: h => h(App),
  beforeCreate() {
    this.$store.dispatch('initializeStore')
    this.$store.commit('setLoadingEvents', false)
	},
  created() {
    this.$store.dispatch('getEvents')
    this.$store.dispatch('getPlaces', 'attraction')
    this.$store.dispatch('getPlaces', 'restaurant')
    this.$store.dispatch('getPlaces', 'park')
    this.$store.dispatch('getActiveAds')
  }
}).$mount('#app')
